export type Role = 'clinical_user' | 'admin_user' | 'on_call_user' | 'manager' | 'admin';

export interface Me {
  userId: string;
  displayName: string;
  roles: Role[];
}

export interface Line {
  id: string;
  resource_account_oid: string;
  number: string | null;
  name: string;
  ring_targets: string;
  ring_timeout_seconds: number | null;
  is_active: boolean;
  recording_notice_blob: string | null;
  team_id: string | null;
  /** The line's Cloud Voicemail mailbox user (0026); null = deployment default. */
  voicemail_user_id: string | null;
  voicemail_user_name: string | null;
}

export type CallState = 'ringing' | 'answered' | 'missed' | 'in_progress';

export const CALL_STATE_LABEL: Record<CallState, string> = {
  ringing: 'Ringing', answered: 'Answered', missed: 'Missed', in_progress: 'In progress',
};

export interface CallRow {
  id: string;
  caller_number: string | null;
  caller_name: string | null;
  originating_queue_name: string | null;
  originating_queue_number: string | null;
  answered_queue_name: string | null;
  state: CallState;
  ringing_at: string;
  answered_at: string | null;
  ended_at: string | null;
  answered_by: string | null;
  call_type: string | null;
  handled_by: string | null;
  notes: string | null;
  completed_at: string | null;
  has_voicemail: boolean;
  line_number: string | null;
  team_id: string | null;
  team_name: string | null;
  include_in_handover: boolean;
}

export interface CallLine {
  number: string;
  name: string;
}

export interface KbItem {
  id: string;
  kind: 'question' | 'action' | 'info';
  text: string;
  sort_order: number;
  is_required: boolean;
  is_done: boolean | null;
  response: string | null;
}

export interface CallDetail extends CallRow {
  knowledgebase: KbItem[];
  /** Present when the call has a voicemail (0025): where it came from and any transcript. */
  voicemail?: { source: 'bot' | 'cloud_voicemail'; transcript: string | null; duration_sec: number | null; recorded_at: string } | null;
}

export interface CallType {
  id: string;
  key: string;
  name: string;
  description: string | null;
  is_fallback: boolean;
  items: { id: string; kind: KbItem['kind']; text: string; sortOrder: number; isRequired: boolean; isActive: boolean }[];
}

export interface AccessGroup {
  id: string;
  entra_oid: string;
  display_name: string;
  created_at: string;
  roles: Role[];
  all_teams: boolean;
  team_ids: string[];
}

export interface AccessAuditRow {
  id: number;
  at: string;
  action: string;
  detail: { role?: string; displayName?: string } | null;
  actor_name: string | null;
  user_name: string | null;
  group_name: string | null;
}

export interface Team {
  id: string;
  name: string;
}

export interface HandoverItem {
  id?: string;
  kind: 'call' | 'note';
  call_id?: string | null;
  call_at?: string | null;
  caller?: string | null;
  call_type?: string | null;
  call_notes?: string | null;
  item_text?: string | null;
  action?: string | null;
}
export interface Handover {
  id: string;
  created_by_name: string | null;
  created_at: string;
  submitted_at: string | null;
  arrived_home: 'yes' | 'no' | 'na' | null;
  arrived_home_notes: string | null;
}
export interface HandoverDetail {
  handover: Handover;
  items: HandoverItem[];
}
export interface HandoverListRow {
  id: string;
  created_by_name: string | null;
  created_at: string;
  submitted_at: string | null;
  item_count: number;
}
